/**
 * @deprecated
 * Use Utilities from `App.Utilities.*`
 * todo: Please sort this methods into specific files under "App/Utilities"
 */
(() => {
    class Utilities {
        constructor() {}

        // taken from mo.js demos
        isIOSSafari() {
            var userAgent;
            userAgent = window.navigator.userAgent;
            return userAgent.match(/iPad/i) || userAgent.match(/iPhone/i);
        }

        // taken from mo.js demos
        isSafari() {
            var userAgent;
            userAgent = window.navigator.userAgent;
            return userAgent.match(/Safari/i);
        }

        // taken from mo.js demos
        isTouch() {
            var isIETouch;
            isIETouch = navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
            return [].indexOf.call(window, 'ontouchstart') >= 0 || isIETouch;
        }

        isMobile(breakpoint = 'sm') {
            if (breakpoint === 'all') {
                if (this.isIOSSafari() || this.isTouch()) {
                    return true;
                } else {
                    return screen.availHeight > screen.availWidth ? (window.innerWidth <= App.Interface.Breakpoint.getWidth('sm')) : (window.innerWidth <= App.Interface.Breakpoint.getWidth('md'));
                }
            } else {
                return (window.innerWidth <= App.Interface.Breakpoint.getWidth(breakpoint));
            }
        }

        parentsUntil(el, selector, filter) {
            let result = [];

            if (el.length) {
                el.forEach(element => {
                    result.push(this.parentUntil(element, selector, filter));
                });
            } else {
                result.push(this.parentUntil(el, selector, filter));
            }

            result = [].concat(...result);

            return result;
        }

        parentUntil(el, selector, filter) {
            const result = [];
            const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
            el = el.parentElement;

            while (el && !matchesSelector.call(el, selector)) {
                if (!filter) {
                    result.push(el);
                } else {
                    if (matchesSelector.call(el, filter)) {
                        result.push(el);
                    }
                }

                el = el.parentElement;
            }

            return result;
        }

        searchAndReplaceTagWithVariable(element) {
            const tag = element.tagName.toLocaleLowerCase();

            if (App.Variable(tag)) {
                element.innerHTML = App.Variable(tag);
            }
        }

        parsePotentiallyGroupedFloat(stringValue) {
            stringValue = stringValue.trim();
            var result = stringValue.replace(/[^0-9]/g, '');

            if (/[,\.]\d{2}$/.test(stringValue)) {
                result = result.replace(/(\d{2})$/, '.$1');
            }

            return parseFloat(result);
        }

        /**
         * @deprecated
         * Use `App.Utilities.String.validateEmail`
         */
        validateEmail(email) {
            return App.Utilities.String.validateEmail(email);
        }
    }

    App.Interface.Utilities = new Utilities();
})();
